import { Role } from './role';

export class User {
  id: number | string;
  email: string;
  password?: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  username?: string;
  avatar?: string;
  role?: Role | string;
  roles?: string[];
  token?: string;
  iamId?: string;
  phoneNumber?: string;
  gender?: string;
  birthday?: string;
  fullAddress?: string;
  isActive?: boolean;
}


